export function parsePresenceUpdateLiveCount(data: unknown): number | null {
  if (!data || typeof data !== 'object') return null;
  const o = data as Record<string, unknown>;
  if (typeof o.live === 'number') return o.live;
  if (typeof o.liveCount === 'number') return o.liveCount;
  return null;
}
